import { useConvexAuth } from 'convex/react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { FullScreenLoader } from '../components/ui/feedback';
import { useWorkOSAuth } from '../lib/auth';
import { consumeAuthReturnTo } from '../lib/routes';

function getMobileBridgeUrl(): string | null {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');
  if (!code || !state?.startsWith('mobile:')) {
    return null;
  }
  return `hit-app://callback?${new URLSearchParams({ code, state }).toString()}`;
}

export default function CallbackPage() {
  const { user, isLoading: authLoading, signIn } = useWorkOSAuth();
  const { isLoading: convexLoading, isAuthenticated } = useConvexAuth();
  const [handoffTimedOut, setHandoffTimedOut] = useState(false);

  // Read once: the mobile app starts sign-in in a browser and receives the code via deep link.
  const [mobileBridge] = useState(getMobileBridgeUrl);

  useEffect(() => {
    if (!mobileBridge) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setHandoffTimedOut(true);
    }, 1600);

    window.location.replace(mobileBridge);
    return () => window.clearTimeout(timeoutId);
  }, [mobileBridge]);

  if (authLoading || convexLoading || (mobileBridge && !handoffTimedOut)) {
    return (
      <FullScreenLoader
        label={mobileBridge ? 'Mobile-Anmeldung wird abgeschlossen...' : 'Anmeldung wird abgeschlossen...'}
      />
    );
  }

  if (user && isAuthenticated) {
    return <Navigate to={consumeAuthReturnTo()} replace />;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <span>V</span>
        </div>

        <h1 className="auth-title">Anmeldung fehlgeschlagen</h1>
        <p className="auth-subtitle">Die Sitzung konnte nicht hergestellt werden. Bitte versuchen Sie es erneut.</p>

        <div className="auth-buttons">
          <button type="button" onClick={() => void signIn()} className="btn btn-primary btn-lg w-full">
            Erneut anmelden
          </button>
        </div>
      </div>
    </div>
  );
}
